import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 4.5V6H16.25V4.5H2.75ZM2.75 13.5H7.25V12H2.75V13.5ZM11.75 9.75H2.75V8.25H11.75V9.75Z",
		fill: "#696F88"
	})
});
export default SvgSort;
